import { render } from "./projects-header.vue?vue&type=template&id=10ba1cb5"
import script from "./projects-header.vue?vue&type=script&lang=js"
export * from "./projects-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__